import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewParadan from "./ViewParadan";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import {
  Get_List_Paradan,
  Update_Paradan,
  View_Paradan_Bill,
} from "../../../actions_agent/Invoice_action";

export class View_Paradan extends Component {
  render() {
    const {
      view_paradan_obj,
      lang,
      change_Lang,
      View_Paradan_Bill,
      Update_Paradan,
      EveryTimeTo_English,
      user,
      list_agents,
      handleCancel,
      Get_List_Paradan,
      name_arb,
      name_en,
      name_krd,
    } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <ViewParadan
            view_paradan_obj={view_paradan_obj}
            lang={lang}
            change_Lang={change_Lang}
            View_Paradan_Bill={View_Paradan_Bill}
            Update_Paradan={Update_Paradan}
            EveryTimeTo_English={EveryTimeTo_English}
            user={user}
            list_agents={list_agents}
            handleCancel={handleCancel}
            Get_List_Paradan={Get_List_Paradan}
            name_arb={name_arb}
            name_en={name_en}
            name_krd={name_krd}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
    paradan_lists: state.Invoice_Reducer.paradan_lists,
    user: state.AuthReducer.user,
    list_agents: state.Invoice_Reducer.list_agents,
    name_krd: state.HelperReducer.name_krd,
    name_arb: state.HelperReducer.name_arb,
    name_en: state.HelperReducer.name_en,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Paradan_Bill: (id, iindex) => dispatch(View_Paradan_Bill(id, iindex)),
    Update_Paradan: (id, data) => dispatch(Update_Paradan(id, data)),
    EveryTimeTo_English: (key) => dispatch(EveryTimeTo_English(key)),
    Get_List_Paradan: () => dispatch(Get_List_Paradan()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View_Paradan);
